module.exports = __webpack_public_path__ + "static/img/3.a7e58c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/3.png
// module id = ugNy
// module chunks = 0